import React from 'react'

export default function NutritionValue(props) {
  
  const { nutrition, serving } = props;

  const transformedNutrition = nutrition.map((item) => ({
    value: (parseFloat(item.value) * parseFloat(serving)).toFixed(2),
    label: item.label,
  }));

  return (
    <div>
    <div className='NutritionValue'>
      <h5>Nutritional Information</h5>
      <div className='MainBox'>
        {transformedNutrition.map((valueObj, index) => (
          <div className='ValueParent' key={index}>
            <span className='value'>{valueObj.value}</span>
            <span className='label'>{valueObj.label}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
  )
}
